import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/header";
import Dashboard from "../dashboard";
import Resources from "../resources";
import Shifts from "../resourcePlanner/Shifts";
import Roles from "../roles";
import Clients from "../client/clients";
import Projects from "../project/projects";
import ScopeItems from "../scopeItem";
import ChangeRequests from "../changeRequest";
import Risks from "../risk";
import Communications from "../communication";
import Budgets from "../budget";
import Portfolios from "../portfolio/portfolios";
import Meetings from "../meetings";
import MeetingRegistery from "../meetingRegistery";
import Settings from "../settings";
import LeftNavigation from "../../components/leftNavigation/LeftNavigation";
import ProjectOverview from "../project/overview";
import ScopeOverview from "../scopeOverview";
import TaskGroupOverview from "../taskGroupOverview";
import ClientOverview from "../client/clientoverview";
import styles from "./LayoutStyles.module.scss";
import { getNavExpand, getNavHidden } from "../../store/selectors/general.selector";
import { useDispatch, useSelector } from "react-redux";
import { updateNavExpand } from "../../store/actions/general.actions";
import Programs from "../program/programs";
import Overview from "../program/overview";
import PortfolioOverview from "../portfolio/overview";
import ResourcePlannerv0 from "../resourcePlanner/ResourcePlannerv0";
import { ResourceMoniteringProvider } from "../resourcePlanner/resourceMonitoring/ResourceContext";
import DashboardHeader from "../dashboard/DashboardHeader";
import MakeSure from "../makeSure/MakeSure";
import TimeSheet from "../timesheet/Timesheet";
import AiProjectCharter from "../ai/AiProjectCharter";
import { ResourcePlannerProvider } from "../resourcePlanner/resourceMonitoring/ResourcePlannerContext";
import ResourcesPlanner from "../ResourcesPlanner/ResourcesPlanner";
import ResourcesReport from "../resourcesReport/ResourcesReport";
import RunbookOverview from "../runbooks/overview";
import TagLibrary from "../admin/tags/TagLibrary";

const Layout = React.memo((props) => {
  const { closeModalRequest } = props;
  const dispatch = useDispatch();
  const navExpand = useSelector(getNavExpand);
  const navHidden = useSelector(getNavHidden);
  const path = window.location.pathname;
  const queryParams = new URLSearchParams(window.location.search);
  const loadComponent = () => {
    const id = path.split("/")[3];
    const envr = process.env.PUBLIC_URL;
    switch (path) {
      case `${envr}/dashboard`:
        return (
          <ResourceMoniteringProvider>
            <DashboardHeader />
          </ResourceMoniteringProvider>
        );
      case `${envr}/roles`:
        return <Roles />;
      case `${envr}/resources`:
        return <Resources />;
      // case `${envr}/shifts`:
      //   return <Shifts />;
      case `${envr}/timesheet`:
        return <TimeSheet />;
      case `${envr}/clients`:
        return <Clients />;
      case `${envr}/projects/${id}/overview`:
        return <ProjectOverview projectID={id} />;
      case `${envr}/clients/${id}/overview`:
        return <ClientOverview clientID={id} />;
      case `${envr}/scopes/${id}/overview`:
        return <ScopeOverview scopeID={id} />;
      case `${envr}/taskgroups/${id}/overview`:
        return <TaskGroupOverview taskGroupID={id} />;
      case `${envr}/projects`:
        return <Projects />;
      case `${envr}/scopeItems`:
        return <ScopeItems />;
      case `${envr}/changeRequests`:
        return <ChangeRequests />;
      case `${envr}/risks`:
        return <Risks />;
      case `${envr}/communications`:
        return <Communications />;
      case `${envr}/budgets`:
        return <Budgets />;
      case `${envr}/meeting`:
        return <Meetings />;
      case `${envr}/resource-planner`:
        return (
          <ResourcesPlanner />
        );
      case `${envr}/resource-reports`:
        return <ResourcesReport />;
      case `${envr}/meetings-registry`:
        return <MeetingRegistery />;
      case `${envr}/portfolio/${id}/overview`:
        return <PortfolioOverview portfolioID={id} />;
      case `${envr}/portfolio`:
        return <Portfolios />;
      case `${envr}/program/${id}/overview`:
        return <Overview programID={id} />;
      case `${envr}/program`:
        return <Programs />;
      case `${envr}/settings`:
        return <Settings />;
      case `${envr}/admin/tags`:
        return <TagLibrary />;
      case `${envr}/deletion-request`:
        const encodedData = queryParams.get("d");
        if (encodedData) {
          try {
            const deleteRequest = JSON.parse(atob(encodedData));
            switch (deleteRequest.type) {
              case 0:
                return (
                  <ClientOverview
                    clientID={deleteRequest.id}
                    deleteRequest={deleteRequest}
                  />
                );
              case 1:
                return (
                  <PortfolioOverview
                    portfolioID={deleteRequest.id}
                    deleteRequest={deleteRequest}
                  />
                );
              case 2:
                return (
                  <Overview
                    programID={deleteRequest.id}
                    deleteRequest={deleteRequest}
                  />
                );
              case 3:
                return (
                  <ProjectOverview
                    projectID={deleteRequest.id}
                    deleteRequest={deleteRequest}
                  />
                );
            }
          } catch (err) {
            console.error("Invalid query data:", err);
          }
        }
        return (
          <ResourceMoniteringProvider>
            <DashboardHeader />
          </ResourceMoniteringProvider>
        );
      case `${envr}/make-sure`:
        return <MakeSure />;
      case `${envr}/ai-create`:
        return <AiProjectCharter />;
      case `${envr}/runbooks/${id}/overview`:
        return <RunbookOverview runbookId={id} />;
      default:
        return (
          <ResourceMoniteringProvider>
            <DashboardHeader />
          </ResourceMoniteringProvider>
        );
    }
  };

  const handleNavExpand = () => {
    dispatch(updateNavExpand());
  };

  const handleClick = () => {
    closeModalRequest();
  };

  ///////// nav hover-preview (Notion-style, triggered from the header hamburger) /////////
  const [navPreview, setNavPreview] = useState(false);
  const navPreviewTimeoutRef = useRef(null);

  const clearNavPreviewTimeout = () => {
    if (navPreviewTimeoutRef.current) {
      clearTimeout(navPreviewTimeoutRef.current);
      navPreviewTimeoutRef.current = null;
    }
  };

  const handleNavPreviewEnter = () => {
    clearNavPreviewTimeout();
    setNavPreview(true);
  };

  const handleNavPreviewLeave = () => {
    clearNavPreviewTimeout();
    navPreviewTimeoutRef.current = setTimeout(() => setNavPreview(false), 200);
  };

  useEffect(() => clearNavPreviewTimeout, []);
  ////////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="layoutMainWrapper" onClick={handleClick}>
      <Header
        onNavPreviewEnter={handleNavPreviewEnter}
        onNavPreviewLeave={handleNavPreviewLeave}
      />

      {/* <div className={styles.layoutBodyWrapper}  style={{ backgroundColor: 'red' , height: '100%'}}> */}
      <div className={styles.layoutBodyWrapper}>
        <LeftNavigation
          handleNavExpand={handleNavExpand}
          navPreview={navPreview}
          onNavPreviewEnter={handleNavPreviewEnter}
          onNavPreviewLeave={handleNavPreviewLeave}
        />
        <div
          className={`${styles.layoutMainPanel} ${
            navHidden
              ? styles.hiddenNavBar
              : navExpand
              ? styles.ExpandedNavBar
              : styles.collapseNavBar
          }`}
        >
          {loadComponent()}
        </div>
      </div>
    </div>
  );
});

export default Layout;
